export const LAYOUT_CONTENT_DESKTOP_MIN_PX = 1024
export const LAYOUT_CONTENT_DESKTOP_WITH_SIDEBAR_MIN_PX = 1280
export const LAYOUT_CONTENT_TABLET_MIN_PX = 768

export interface LayoutContentBreakpoint {
  contentWidth: number
  isDesktop: boolean
  isDesktopWithSidebar: boolean
  isTablet: boolean
  isMobile: boolean
  isCompact: boolean
}

export function buildLayoutContentBreakpoint (contentWidth: number): LayoutContentBreakpoint {
  const safeWidth = Math.max(0, contentWidth)

  return {
    contentWidth: safeWidth,
    isDesktop: safeWidth >= LAYOUT_CONTENT_DESKTOP_MIN_PX,
    isDesktopWithSidebar: safeWidth >= LAYOUT_CONTENT_DESKTOP_WITH_SIDEBAR_MIN_PX,
    isTablet: safeWidth >= LAYOUT_CONTENT_TABLET_MIN_PX && safeWidth < LAYOUT_CONTENT_DESKTOP_MIN_PX,
    isMobile: safeWidth < LAYOUT_CONTENT_TABLET_MIN_PX,
    isCompact: safeWidth < LAYOUT_CONTENT_DESKTOP_MIN_PX
  }
}
